// extracted by mini-css-extract-plugin
export default {"user":"styles_user__m0Yvh","edit":"styles_edit__P1jCq","delete":"styles_delete__-xX-2","table_container":"styles_table_container__y1udL","userImage":"styles_userImage__sPyo0"};